import cn from 'classnames';
import {TabComponent} from './Agent';

import {dataBuilder as data, moduleTitleCn} from '~/locals/aigallery/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

import styles from '~/style/aigallery/dataBuilder.module.less';
import styleCom from '~/style/aigallery/common.module.less';

const id = 'dataBuilder';

const DataBuilder = () => {
    const {title} = data;
    useCptDuration(id, {
        name: `${applicationName}-DataBuilder-停留时长`
    });
    return (
        <div className={cn(styles['data-builder'], styleCom['modules-padding'])} id={id}>
            <h2 className={`${moduleTitleCn}`}>{title}</h2>
            <div className={`${moduleTitleCn}`}>
                <TabComponent data={{...data, isGrey: true}} />
            </div>
        </div>
    );
};

export default DataBuilder;
